import { IRouteConfigWithMeta } from '@/router/interfaces';

export default [
  {
    name: 'app',
    path: '/',
    redirect: '/profile',
    children: [
      {
        name: 'profile',
        path: '/profile',
        component: () => import('@/views/App/Profile/Profile.vue'),
        meta: {
          guard: true,
          analyticsName: 'main',
        },
      },
      {
        name: 'profileEdit',
        path: '/profile/edit',
        component: () => import('@/views/App/ProfileSettings/ProfileEdit.vue'),
        meta: {
          guard: true,
          analyticsName: 'profile',
        },
      },
      {
        name: 'profilePassport',
        path: '/profile/passport',
        component: () => import('@/views/App/ProfileSettings/ProfilePassport.vue'),
        meta: {
          guard: true,
          analyticsName: 'profilePassport',
        },
      },
      {
        name: 'profileDocuments',
        path: '/profile/documents',
        component: () => import('@/views/App/ProfileSettings/ProfileDocuments.vue'),
        meta: {
          guard: true,
          analyticsName: 'documents',
        },
      },
      {
        name: 'personalPage',
        path: '/personal-page',
        component: () => import('@/views/App/PersonalPage/PersonalPage.vue'),
        meta: {
          guard: true,
          analyticsName: 'personal',
        },
      },
      {
        name: 'ConstructionStages',
        path: '/construction/:id',
        component: () => import('@/views/App/ConstructionStages/ConstructionStages.vue'),
        meta: {
          guard: true,
          analyticsName: 'constructionStages',
        },
      },
      {
        name: 'deal',
        path: '/deal',
        redirect: '/deal/ownership',
        component: () => import('@/views/App/Deal/Deal.vue'),
        meta: {
          guard: true,
          analyticsName: 'deal',
        },
        children: [
          {
            name: 'ownershipDetails',
            path: '/deal/ownership',
            component: () => import('@/views/App/Deal/OwnershipDetails.vue'),
            meta: {
              guard: true,
              analyticsName: 'ownershipDetails',
            },
          },
          {
            name: 'paymentDetails',
            path: '/deal/payment',
            component: () => import('@/views/App/Deal/PaymentDetails.vue'),
            meta: {
              guard: true,
              analyticsName: 'paymentDetails',
            },
          },
          {
            name: 'contractDetails',
            path: '/deal/contract',
            component: () => import('@/views/App/Deal/ContractDetails.vue'),
            meta: {
              guard: true,
              analyticsName: 'contractDetails',
            },
          },
          {
            name: 'signingOptions',
            path: '/deal/signing',
            component: () => import('@/views/App/Deal/SigningOptions.vue'),
            meta: {
              guard: true,
              analyticsName: 'signingOptions',
            },
          },
        ],
      },
      {
        name: 'checkList',
        path: '/check-list/:leadId',
        props: true,
        component: () => import('@/views/App/CheckList/CheckList.vue'),
        meta: {
          guard: true,
          analyticsName: 'checkList',
        }
      }
    ],
    component: () => import('@/views/App/Main.vue'),
  },
] as IRouteConfigWithMeta[];
